import Vue from 'vue';
import { PET_MENU_PATHS, normalizeNavigationPath } from '@/utils/navigation';
import { TOKEN_KEY, TENANT_ID_KEY } from '@/config';

export const accessState = Vue.observable({ loaded: false, error: '', menuPaths: [], permissions: [], roles: [], superAdmin: false });
let activeKey = '';
let generation = 0;
let pending = null;

export function accessScope() {
  return [localStorage.getItem(TOKEN_KEY), localStorage.getItem(TENANT_ID_KEY), localStorage.getItem('shopId')].join('|');
}
export function resetAccess() {
  generation++;
  pending = null;
  activeKey = '';
  Object.assign(accessState, { loaded: false, error: '', menuPaths: [], permissions: [], roles: [], superAdmin: false });
}
export function canVisit(path) {
  return accessState.loaded && accessScope() === activeKey && accessState.menuPaths.includes(normalizeNavigationPath(path));
}
export function hasPermission(permission) {
  return accessState.loaded && accessScope() === activeKey && accessState.permissions.includes(permission);
}
export async function refreshAccess(force = false) {
  const key = accessScope();
  if (key !== activeKey) { resetAccess(); activeKey = key; }
  if (pending && !force) return pending;
  if (force && pending) { generation++; pending = null; }
  if (accessState.loaded && !force) return accessState;
  const ticket = ++generation;
  const task = (async () => {
    try {
      const { getCurrentAccess } = await import('@/api/access');
      const response = await getCurrentAccess();
      if (ticket !== generation || key !== accessScope()) throw new Error('门店或登录状态已变更，请重试');
      const data = response.data || {};
      if (!Array.isArray(data.menuPaths) || !Array.isArray(data.permissions)) throw new Error('权限数据不完整，请重试');
      const menuPaths = data.menuPaths.filter((path) => typeof path === 'string').map(normalizeNavigationPath);
      // Older servers expose the shared pet:view grant at /pets; keep saved links and all four sections usable.
      if (data.menuPaths.includes('/pets') && data.permissions.includes('pet:view')) menuPaths.push(...PET_MENU_PATHS);
      Object.assign(accessState, { loaded: true, error: '', menuPaths: [...new Set(menuPaths)], permissions: data.permissions, roles: data.roles || [], superAdmin: data.superAdmin === true });
      return accessState;
    } catch (error) {
      if (ticket !== generation || key !== accessScope()) throw Object.assign(new Error('权限读取已由新的请求接管'), { code: 'ACCESS_SUPERSEDED' });
      if (ticket === generation) Object.assign(accessState, { loaded: false, error: error.message || '权限读取失败', menuPaths: [], permissions: [], roles: [], superAdmin: false });
      throw error;
    } finally { if (ticket === generation) pending = null; }
  })();
  pending = task;
  return task;
}
